<template>
  <div class="cont-box">
    <img src="../../assets/wxdj-head.png">
    <div class="cont">
      <el-form label-position="top" label-width="80px" ref="subData" :model="subData">
        <el-form-item label="维修区域:" prop="fixArea">
          <el-input v-model="subData.fixArea" placeholder="暂无数据" readonly></el-input>
        </el-form-item>
        <el-form-item label="具体维修地点:" prop="fixPoint">
          <el-input v-model="subData.fixPoint" placeholder="暂无数据" readonly></el-input>
        </el-form-item>
        <el-form-item label="报修人与联系方式:" prop="nameAndPhone">
          <el-input v-model="subData.nameAndPhone" placeholder="暂无数据" readonly></el-input>
        </el-form-item>
        <el-form-item label="维修事项:" prop="remark">
          <el-input type="textarea" rows="4" v-model="
          subData.remark" placeholder="暂无数据" readonly></el-input>
        </el-form-item>
        <el-form-item label="问题图片:" prop="file">
          <div class="demo-image__preview">
            <el-badge :value="subData.file.length" class="item">
              <el-image
                style="width: 50px; height: 42px; opacity: .8;"
                :src="require('@/assets/img-thumb.png')"
                :preview-src-list="files">
              </el-image>
            </el-badge>
          </div>
          
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        axios: axios,
        subData: {
          fixArea: '公共区域',
          fixPoint: '11',
          nameAndPhone: '22',
          remark: '33',
          file: [],
        },
      }
    },
    mounted() {
      this.getInfo()
    },
    computed: {
      files() {
        let arr = []
        this.subData.file.map(item => {
          arr.push(item.filePath)
        })
        return arr
      }
    },
    methods: {
      getInfo() {
        let id = this.$route.query.id || 0
        this.$axios.post('/PropertyServer/findOneList', {id}).then((res) => {
          this.subData = res.data.data
        })
      }
    }
  }
</script>

<style scoped>
  .cont-box {

  }

  .cont-box>img {
    width: 100%;
  }


  .el-form {
    padding: 0 2rem;
  }
  
  .el-select {
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .logo {
    width: 40%;
    padding: 2rem 0 1rem;
  }

  .title {
    width: 60%;
  }

  .title-d {
    color: #e8380d;
    padding: 0.8rem 0;
  }

  .el-form--label-top>>>.el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  .el-button {
    width: 100%;
  }

  .el-button.sub-btn {
    margin: 1rem 0 3rem;
    background: linear-gradient(#ed6404, #e8320d);
    border: none;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 1rem 0;
  }
  
  .el-button.sub-btn:active {
    filter: drop-shadow(0 1px 4px #ed6404);
  }

  .el-button.pop-btn {
    width: 6rem;
    background-color: #e8320d;
    border: none;
    margin: 1rem 0 .5rem;
  }

  .pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pop-cont {
    box-sizing: border-box;
    width: 72%;
    height: 16rem;
    background: white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
  }

  .pop-cont>p:nth-of-type(1) {
    font-size: 1.2rem;
    font-weight: bold;
    margin: .5rem 0 1rem;
  }

  .pop-cont>p:nth-of-type(2) {
    color: #e8320d;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: .5rem;
  }

  .pop-cont>p:nth-of-type(3) {
    color: #646464;
    text-align: center;
    line-height: 2rem;
  }

  .der {
    padding: 0 2rem 2rem;
  }

  .der>p {
    line-height: 1.8rem;
    color: #e8320d;
  }

  .der>p>span:nth-of-type(1) {
    font-weight: bold;
  }

  .der>p:nth-of-type(2) {
    margin-top: .5rem;
    font-size: .8rem;
    color: #646464;
    line-height: 1.2rem;
  }

  .my-upload>>>.el-upload {
    width: 100%;
  }
  
  .el-input >>> .el-input__inner, .el-textarea >>> .el-textarea__inner {
    color: #323232;
  }
</style>
